import { NgModule } from '@angular/core';
import {
  JSONLD_LOCAL_BUSINESS_BUILDER,
  JSONLD_PRODUCT_BUILDER,
  SCHEMA_BUILDER,
} from '../tokens';
import { OrganizationSchemaBuilder } from './organization/organization-schema.builder';
import { BoelsBreadcrumbSchemaBuilder } from './breadcrumb/boels-breadcrumb-schema.builder';
import { ProductSchemaBuilder } from './product/product-schema.builder';
import { JsonLdProductBaseBuilder } from './product/jsonld-product-base.builder';
import { JsonLdProductOfferBuilder } from './product/jsonld-product-offer.builder';
import { LocalBusinessSchemaBuilder } from './local-business/local-business-schema.builder';
import { JsonldLocalBusinessAddressBuilder } from './local-business/jsonld-local-business-address.builder';
import { JsonldLocalBusinessGeoBuilder } from './local-business/jsonld-local-business-geo.builder';
import { JsonldLocalBusinessOpeningTimesBuilder } from './local-business/jsonld-local-business-opening-times.builder';
import { JsonldLocalBusinessBaseBuilder } from './local-business/jsonld-local-business-base.builder';
import { JsonldLocalBusinessBranchBuilder } from './local-business/jsonld-local-business-branch.builder';

@NgModule({
  providers: [
    OrganizationSchemaBuilder,
    BoelsBreadcrumbSchemaBuilder,
    ProductSchemaBuilder,
    JsonLdProductBaseBuilder,
    JsonLdProductOfferBuilder,
    LocalBusinessSchemaBuilder,
    JsonldLocalBusinessAddressBuilder,
    JsonldLocalBusinessGeoBuilder,
    JsonldLocalBusinessOpeningTimesBuilder,
    JsonldLocalBusinessBaseBuilder,
    JsonldLocalBusinessBranchBuilder,
    {
      provide: SCHEMA_BUILDER,
      useExisting: OrganizationSchemaBuilder,
      multi: true,
    },
    {
      provide: SCHEMA_BUILDER,
      useExisting: BoelsBreadcrumbSchemaBuilder,
      multi: true,
    },
    {
      provide: SCHEMA_BUILDER,
      useExisting: ProductSchemaBuilder,
      multi: true,
    },
    {
      provide: JSONLD_PRODUCT_BUILDER,
      useExisting: JsonLdProductBaseBuilder,
      multi: true,
    },
    {
      provide: JSONLD_PRODUCT_BUILDER,
      useExisting: JsonLdProductOfferBuilder,
      multi: true,
    },
    {
      provide: SCHEMA_BUILDER,
      useExisting: LocalBusinessSchemaBuilder,
      multi: true,
    },
    {
      provide: JSONLD_LOCAL_BUSINESS_BUILDER,
      useExisting: JsonldLocalBusinessBaseBuilder,
      multi: true,
    },
    {
      provide: JSONLD_LOCAL_BUSINESS_BUILDER,
      useExisting: JsonldLocalBusinessBranchBuilder,
      multi: true,
    },
    {
      provide: JSONLD_LOCAL_BUSINESS_BUILDER,
      useExisting: JsonldLocalBusinessGeoBuilder,
      multi: true,
    },
    {
      provide: JSONLD_LOCAL_BUSINESS_BUILDER,
      useExisting: JsonldLocalBusinessAddressBuilder,
      multi: true,
    },
    {
      provide: JSONLD_LOCAL_BUSINESS_BUILDER,
      useExisting: JsonldLocalBusinessOpeningTimesBuilder,
      multi: true,
    },
  ],
})
export class JsonLdBuilderModule {}
